import React from 'react'
import './Galleryhero.css'
import POOJA from '../images/11.jpg'

export default function Galleryhero() {
  return (
    <>
      <section id="Galleryhero" style={{ backgroundImage: `url(${POOJA})` }}>
        <div className="gallery-overlay">
          <h1 className="gallery-title">
           ONLINE SHIVA NADI ASTROLOGY
          </h1>
          <p className="gallery-slogan">
            Capturing Divine Moments, Forever in Time ✨
          </p>
        </div>
      </section>
    </>
  )
}
